import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error module is untyped
import localeComparator from 'I18n/utils/localeComparator';
import unescapedText from 'I18n/utils/unescapedText';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
let cachedOptions;
const optionValues = ['ANY', 'BLOG_LISTING', 'BLOG_POST', 'PAGE'];

function getOptions() {
  if (!cachedOptions) {
    cachedOptions = optionValues.map(value => ({
      text: unescapedText(`marketplace-assets-ui.assets.filters.templateTypes.options.${value}`),
      value
    })).sort((a, b) => localeComparator(a.text, b.text));
  }

  return cachedOptions;
}

export default function TemplateTypeFilter({
  disabled,
  onChange,
  scrollable = true,
  value
}) {
  const options = getOptions();
  return /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('marketplace-assets-ui.assets.filters.templateTypes.title'),
    disabled: disabled,
    multi: true,
    name: "templateTypes",
    onChange: onChange,
    options: options,
    scrollable: scrollable,
    value: value
  });
}